import Vue from 'vue'
import uiAlert from './uiAlert.vue'

const VueComponent = Vue.extend(uiAlert)
const vm = new VueComponent().$mount()
let init = false
let defaultOptions = { value: true }

const alert = function (options) {
  Object.assign(vm, defaultOptions, options, {
    type: 'uiAlert'
  })

  if (!init) {
    document.body.appendChild(vm.$el)
    init = true
  }
  return vm.alert('el')
}

export default alert


// WEBPACK FOOTER //
// ./src/component/uiAlert/index.js